/**
 *
 * CustomIndicators
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import makeSelectCustomIndicators, {
  makeSelectSurveyTypes,
  makeSelectIsLoading,
} from "./selectors"
import reducer from "./reducer"
import saga, { getSwitchSurveyTypesSaga } from "./saga"
import "./index.less"
import { Checkbox, Popover, Switch, Table, Tooltip } from "antd"
import { QuestionCircleFilled } from "@ant-design/icons"
import { getSurveyTypesWatcher, getSwitchSurveyTypesWatcher } from "./actions"
import { Link } from "react-router-dom"

/* eslint-disable react/prefer-stateless-function */
export class CustomIndicators extends React.Component {
  componentDidMount() {
    this.props.getSurveyTypesWatcher()
  }

  segmentsTitle() {
    const content = (
      <div style={{ fontSize: "13px" }}>
        La <strong>segmentación</strong> elegida será utilizada para{" "}
        <strong>calcular</strong> y <strong>agrupar los resultados</strong>
        <br />
        mostrados en <strong>Reportes</strong>.
        <br />
        <ul style={{ listStylePosition: "outside", marginLeft: "16px" }}>
          <li>
            <strong>Divisiones:</strong> Las respuestas de los colaboradores
            serán segmentadas en base a la
            <br />
            división a la cual estén asignados. Los resultados de una división
            contemplarán
            <br />
            todas las respuestas de las subdivisiones de la misma, a lo largo de
            toda su línea
            <br />
            jerárquica.
          </li>
          <li>
            <strong>Líderes:</strong> Las respuestas de los colaboradores serán
            segmentadas en base al líder
            <br /> directo que tienen asignado. Los resultados de un líder
            contemplan únicamente
            <br /> las respuestas de sus reportes directos.
          </li>
        </ul>
      </div>
    )
    return (
      <span>
        Segmentación
        <Popover content={content} placement="bottom">
          <QuestionCircleFilled
            style={{
              color: "#A7A3A3",
              marginLeft: "8px",
              verticalAlign: "middle",
            }}
          />
        </Popover>
      </span>
    )
  }

  calculationCriteriaTitle() {
    const content = (
      <div style={{ fontSize: "13px" }}>
        El <strong>criterio de cálculo</strong> elegido será el que se utilice
        para <strong>calcular los resultados</strong> a<br />
        mostrar en los <strong>Reportes</strong> de tu medición.
        <br />
        <ul style={{ listStylePosition: "outside", marginLeft: "16px" }}>
          <li>
            <strong>Top Two Box:</strong> porcentaje (%) de personas que
            respondieron 4 o 5 a las distintas
            <br /> preguntas que componen el cuestionario.
          </li>
          <li>
            <strong>Promedio simple:</strong> promedio de los valores de las
            respuestas a las preguntas que
            <br /> componen el cuestionario.
          </li>
        </ul>
      </div>
    )
    return (
      <span>
        Criterio de cálculo
        <Popover content={content} placement="bottom">
          <QuestionCircleFilled
            style={{
              color: "#A7A3A3",
              marginLeft: "8px",
              verticalAlign: "middle",
            }}
          />
        </Popover>
      </span>
    )
  }

  anonymityTitle() {
    const content = (
      <div style={{ fontSize: "13px" }}>
        El <strong>anonimato</strong> configurado será la{" "}
        <strong>cantidad mínima</strong> de personas que deben
        <br />
        contestar la encuesta para mostrar los resultados en cada posible
        segmentación.
      </div>
    )
    return (
      <span>
        Anonimato
        <Popover content={content} placement="bottom">
          <QuestionCircleFilled
            style={{
              color: "#A7A3A3",
              marginLeft: "8px",
              verticalAlign: "middle",
            }}
          />
        </Popover>
      </span>
    )
  }

  tableColumns() {
    const columns = [
      {
        title: "Indicador",
        dataIndex: "survey_type_name",
        key: "survey_type_name",
        render: (text, record) =>
          record.coming_soon === 0 ? (
            <Link
              className="link-indicators"
              to={`/control-panel/indicator/${record.id_company_has_survey_type}#form-indicator`}>
              {text}
            </Link>
          ) : (
            <span>{text}</span>
          ),
      },
      {
        title: this.calculationCriteriaTitle(),
        dataIndex: "calculation_name",
        key: "calculation_name",
      },
      {
        title: this.segmentsTitle(),
        dataIndex: "segmentation_name",
        key: "segmentation_name",
      },
      {
        title: this.anonymityTitle(),
        dataIndex: "anonymity",
        key: "anonymity",
        render: (text, _) => <span>{text || "-"}</span>,
      },
      {
        title: "Estado",
        dataIndex: "status",
        render: (text, record) =>
          record.coming_soon ? (
            <span>Próximamente</span>
          ) : record.measures_in_use > 0 ? (
            <Popover
              content={
                <div>
                  No es posible desactivar un indicador que está siendo
                  utilizado en una medición “Pendiente”, “En curso” o
                  “Finalizada”. Deberás oficializarla antes de poder realizar
                  cambios.
                </div>
              }
              overlayStyle={{
                width: "450px",
              }}>
              <Switch
                checked={record.active === 1}
                disabled={record.measures_in_use > 0}
                onChange={(e) =>
                  this.props.switchSurveyTypesWatcher({
                    active: e,
                    id_company_has_survey_type:
                      record.id_company_has_survey_type,
                  })
                }
              />
            </Popover>
          ) : (
            <Switch
              checked={record.active === 1}
              disabled={record.measures_in_use > 0}
              onChange={(e) =>
                this.props.switchSurveyTypesWatcher({
                  active: e,
                  id_company_has_survey_type: record.id_company_has_survey_type,
                })
              }
            />
          ),
      },
    ]
    return columns
  }

  render() {
    return (
      <div className="container-custom-indicators">
        <div>Configura los indicadores que medirás en tu organización.</div>
        <div className="table-indicators">
          <Table
            dataSource={this.props.surveyTypes}
            loading={this.props.isLoading}
            size="middle"
            bordered
            columns={this.tableColumns()}
          />
        </div>
      </div>
    )
  }
}

CustomIndicators.propTypes = {
  dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  customIndicators: makeSelectCustomIndicators(),
  isLoading: makeSelectIsLoading(),
  surveyTypes: makeSelectSurveyTypes(),
})

function mapDispatchToProps(dispatch) {
  return {
    getSurveyTypesWatcher: (params) => dispatch(getSurveyTypesWatcher(params)),
    switchSurveyTypesWatcher: (params) =>
      dispatch(getSwitchSurveyTypesWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "customIndicators", reducer })
const withSaga = injectSaga({ key: "customIndicators", saga })

export default compose(withReducer, withSaga, withConnect)(CustomIndicators)
